import { makeVar } from '@apollo/client'
import { ColumnHeaderMenuState, RowContextMenuState } from 'components/AgGrid/types'

export const isColumnHeaderRightClickMenuVar = makeVar<ColumnHeaderMenuState | false>(false)
export const showCustomizeColumnsVar = makeVar<any>(false)

export const showAdvFilterVar = makeVar<any>(false)

export const isAssignmentsColumnHeaderRightClickMenuVar = makeVar<ColumnHeaderMenuState | false>(
  false
)
export const showAssignmentsCustomizeColumnsVar = makeVar<any>(false)

export const showAssignmentsAdvFilterVar = makeVar<any>(false)

// Row context menu state for Approvals table
export const isApprovalsRowContextMenuVar = makeVar<RowContextMenuState | false>(false)
